module.exports = __webpack_public_path__ + "img/shuixian3.443a2140.gif";